import { publish } from "@whilecat/core/events/event-service.js";
import { TASK_COMPLETED } from "@whilecat/core/events/task-events.js";
import { schedule } from "@whilecat/core/utils/time.js";
import { LitElement, type PropertyValues } from "lit";
import { property, state } from "lit/decorators.js";
import { assertIsUuid, requireNotNull } from "../utils/validation.ts";
import { taskStyles } from "./task-styles.ts";

export abstract class BaseTask<T> extends LitElement {
    static styles = taskStyles;

    @state() completed!: boolean;
    @property({ reflect: true }) taskId!: string;
    @property({ attribute: false }) data!: T;
    @property({ attribute: false, type: Boolean }) repetitionMode!: boolean;

    gaveUp = false;

    firstUpdated(_changedProperties: PropertyValues) {
        super.firstUpdated(_changedProperties);

        requireNotNull(this.data);
        assertIsUuid(this.taskId);
        requireNotNull(this.completed);
        requireNotNull(this.repetitionMode);

        this.classList.add("task-impl");

        try {
            this.validateData();
        } catch (e) {
            console.error(`Validation for task ${this.taskId} failed:`, e);
        }

        if (this.completed) {
            schedule(() => this.showCorrectAnswer());
        }

        document.addEventListener("keydown", event => {
            if (event.key === "/" && event.metaKey) {
                // FIXME: THIS IS A DEBUG FEATURE: SHOULD BE DISABLED IN PRODUCTION
                console.log("Meta + p: THIS IS A DEBUG FEATURE: SHOULD BE DISABLED IN PRODUCTION");
                this.showCorrectAnswer();
            }
        });
    }

    /**
     * Must be implemented by child classes and verify provided answers
     */
    verify(): void {}

    /**
     * Can be overriden by child classes and show the correct answer
     */
    showCorrectAnswer(): void {}

    /**
     * Can be overriden by child classes to perform any necessary cleanup after the next
     * task button is pressed.
     */
    async cleanup(repetitionMode: boolean): Promise<void> {}

    protected validateData(): void {}

    publishCompleted() {
        this.completed = true;
        publish(TASK_COMPLETED, { taskId: this.taskId, gaveUp: this.gaveUp });
    }

    _completeTask() {
        this.showCorrectAnswer();
        this.verify();
    }
}
